import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import { Box, Tooltip } from '@lyearn/ui';

import { DeviceButtonProps } from '../../types';

const buttonRadius = css`
  border-radius: 0.6rem;
`;

const DeviceButton: React.FC<DeviceButtonProps> = ({ device, onSelect, selected }) => {
  return (
    <Tooltip placement="bottom" title={device.name!}>
      <Box
        className={cn(
          'cursor-pointer p-6 transition-colors transition-opacity hover:bg-bg-hover hover:opacity-100',
          buttonRadius,
          {
            'opacity-100': selected,
            'opacity-25': !selected,
          },
        )}
        onClick={onSelect.bind(null, device.id)}>
        {device.Icon}
      </Box>
    </Tooltip>
  );
};

export default DeviceButton;
